import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import Dashboard from '../components/admin/Dashboard';
import OrdersManagement from '../components/admin/OrdersManagement';
import ProductsManagement from '../components/admin/ProductsManagement';
import CategoriesManagement from '../components/admin/CategoriesManagement';
import EnhancedProductsManagement from '../components/admin/EnhancedProductsManagement';
import NotificationsPanel from '../components/admin/NotificationsPanel';
import EnhancedOrdersManagement from '../components/admin/EnhancedOrdersManagement';
import ServicesManagement from '../components/admin/ServicesManagement';
import CustomersManagement from '../components/admin/CustomersManagement';
import BookingsManagement from '../components/admin/BookingsManagement';
import PurchasesManagement from '../components/admin/PurchasesManagement';
import ModificationsManagement from '../components/admin/ModificationsManagement';
import HeroManagement from '../components/admin/HeroManagement';
import HeroSliderManagement from '../components/admin/HeroSliderManagement';
import SeedData from '../components/admin/SeedData';
import ClearSeedData from '../components/admin/ClearSeedData';

const AdminPanel = () => {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { currentUser, logout } = useAuth();

  if (!currentUser) {
    return <Navigate to="/admin/login" />;
  }

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const renderContent = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard />;
      case 'orders':
        return <EnhancedOrdersManagement />;
      case 'bookings':
        return <BookingsManagement />;
      case 'purchases':
        return <PurchasesManagement />;
      case 'categories':
        return <CategoriesManagement />;
      case 'products':
        return <EnhancedProductsManagement />;
      case 'accessories':
        return <ProductsManagement category="accessories" />;
      case 'parts':
        return <ProductsManagement category="parts" />;
      case 'services':
        return <ServicesManagement />;
      case 'notifications':
        return <NotificationsPanel />;
      case 'customers':
        return <CustomersManagement />;
      case 'modifications':
        return <ModificationsManagement />;
      case 'hero':
        return <HeroSliderManagement />;
      case 'seed-data':
        return <SeedData />;
      case 'clear-seed-data':
        return <ClearSeedData />;
      case 'analytics':
        return (
          <div className="bg-white rounded-xl shadow-md p-12 text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">التحليلات المتقدمة</h2>
            <p className="text-gray-600">قريباً...</p>
          </div>
        );
      case 'settings':
        return (
          <div className="bg-white rounded-xl shadow-md p-12 text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">الإعدادات</h2>
            <p className="text-gray-600">قريباً...</p>
          </div>
        );
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100" dir="rtl">
      {/* Sidebar */}
      <AdminSidebar
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onLogout={handleLogout}
        isMobileOpen={mobileMenuOpen}
        setIsMobileOpen={setMobileMenuOpen}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <AdminHeader
          toggleMobileMenu={toggleMobileMenu}
          currentUser={currentUser}
          onNotificationsClick={() => setCurrentPage('notifications')}
        />

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-4 lg:p-8">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;
